import { render, staticRenderFns } from "./MonthSettings.vue?vue&type=template&id=38c69410&scoped=true&"
import script from "./MonthSettings.vue?vue&type=script&lang=js&"
export * from "./MonthSettings.vue?vue&type=script&lang=js&"
import style0 from "./MonthSettings.vue?vue&type=style&index=0&id=38c69410&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c69410",
  null
  
)

export default component.exports